export const LIMIT = 10
export const SESSION_EXPIRED_ERROR_CODE = 10
export const SORT = 'created_at_desc'
export const TWO_FACTOR_VERIFY_ERROR_CODE = 11
export const SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE'
export const MAINTENANCE_MODE_ERROR_CODE = 10003
